import { addSelectedFiltersToQuery } from 'src/utils/utils';
import { request } from '../api';

export type DeviceListCounts = { alarms: { total: number; byCriticality: Record<string, number> }; workOrders: number };

export interface DeviceListCircuit extends DeviceListCounts {
  id: string;
  tag: string;
  description: string | null;
  model: string | null;
  unit: string | null;
  offline: boolean;
  forcedOn: boolean;
  loto: boolean;
}

export interface DeviceListItem extends DeviceListCounts {
  id: string;
  kind: 'controller' | 'standaloneCircuit';
  tag: string;
  description: string | null;
  model: string | null;
  unit: string | null;
  panel: { id: string; tag: string } | null;
  commLoop: { id: string; tag: string } | null;
  group?: { id: string; name: string };
  offline: boolean;
  forcedOn: boolean;
  loto: boolean;
  matched: boolean;
  circuitCount: number;
  rollup: DeviceListCounts;
  circuits: DeviceListCircuit[];
}

export interface DeviceListResponse {
  data: DeviceListItem[];
  /** Top-level rows; pages are counted in these. (ie controllers) */
  total: number;
  /** Rows plus their matching circuits, across all pages. */
  deviceCount: number;
  offset: number;
  nextOffset: number;
  hasMore: boolean;
}

export interface DeviceListScope {
  panelId?: string;
  commLoopId?: string;
  groupId?: string;
  groupBy?: 'group' | 'connection';
  controllerId?: string;
}

const SCOPE_KEYS = ['panelId', 'commLoopId', 'groupId', 'groupBy', 'controllerId'] as const;

export const deviceListScopeKey = (scope?: DeviceListScope): string =>
  SCOPE_KEYS.map((key) => scope?.[key] ?? '').join('|');

export const deviceListItemKey = (item: Pick<DeviceListItem, 'id' | 'group'>): string =>
  item.group ? `${item.group.id}:${item.id}` : item.id;

export interface DeviceListQuery {
  selectedFilters: any;
  sort: string;
  scope?: DeviceListScope;
}

const PAGE_SIZE = 25;

export const getDeviceList = (action, { selectedFilters, sort, scope }: DeviceListQuery, offset: number): Promise<DeviceListResponse> => {
  const query: any = addSelectedFiltersToQuery(selectedFilters, { sort, offset, limit: PAGE_SIZE });
  SCOPE_KEYS.forEach((key) => {
    if (scope?.[key]) query[key] = scope[key];
  });

  return request(action, {
    payload: {
      url: '/eht-controllers/list',
      query,
      options: { method: 'GET' }
    },
    normalize: (data) => data.toJS()
  });
};
